import { Space } from 'antd';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  height: 32px;
  width: fit-content;
  // min-width: 126px;
  border-radius: 4px;
  padding: 4px;
  background: var(--primary);

  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;

  color: white;
  font-weight: 600;
  cursor: pointer;

  transition: background 0.3s;

  &:hover {
    // background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    //   var(--primary);
    background: var(--hover-primary-1);
  }

  &.disabled {
    opacity: 0.6;
    cursor: default;
    pointer-events: none;
  }

  > .filterIcon {
    display: flex;
    align-items: center;

    width: 15px;
    margin-right: auto;
    margin-left: 10px;

    svg {
      height: 15px;
    }
    path {
      // fill: white;
      stroke-width: 0.5;
    }
  }
`;

export const QuantityWrapper = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  height: 24px;
  padding: 0 8px;
  border-radius: 2px;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  color: var(--color);
`;

// export const CustomCheckboxOption = styled(Checkbox.Group)`
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
//   width: 100%;
//   min-width: fit-content;
//   border-radius: 4px;
//   padding: 8px 0;

//   display: flex;
//   flex-direction: column;

//   .ant-checkbox-wrapper {
//     margin: 0;
//     padding: 0 4px;
//   }
// `;

export const CustomDropdown = styled(Space)`
  width: 100%;

  .buttons {
    display: flex;
    gap: 8px;
    min-width: 200px;
  }
`;
